(() => {
  const mounted = new WeakSet();

  function draftKey(form) {
    return `isso-korea-contact-draft:${form.id || 'default'}`;
  }

  function hydrateContactForm(wrapper) {
    const form = wrapper.querySelector('form');
    if (!form || form.dataset.ikContactMounted === 'true') return;
    form.dataset.ikContactMounted = 'true';
    const key = draftKey(form);
    const state = wrapper.querySelector('[data-ik-contact-state]')?.dataset.ikContactState;
    const submit = form.querySelector('[data-ik-contact-submit]');
    const label = form.querySelector('[data-ik-contact-submit-label]');

    if (state === 'success') {
      try { sessionStorage.removeItem(key); } catch (_error) {}
      return;
    }

    try {
      const saved = sessionStorage.getItem(key);
      if (saved) {
        const values = JSON.parse(saved);
        Object.entries(values).forEach(([name, value]) => {
          if (!name.startsWith('contact[')) return;
          const field = form.elements.namedItem(name);
          if (field && typeof field.value !== 'undefined') field.value = value;
        });
      }
    } catch (_error) {}

    form.addEventListener('submit', () => {
      try {
        const values = {};
        new FormData(form).forEach((value, name) => {
          if (typeof value === 'string' && name.startsWith('contact[')) values[name] = value;
        });
        sessionStorage.setItem(key, JSON.stringify(values));
      } catch (_error) {}
      submit?.classList.add('is-submitting');
      submit?.setAttribute('disabled', 'disabled');
      if (label) label.textContent = '문의 전송 중…';
    });
  }

  function mountSupport(root) {
    if (!root || mounted.has(root)) return;
    mounted.add(root);
    const backdrop = root.querySelector('[data-ik-support-backdrop]');
    const openButton = root.querySelector('[data-ik-support-open]');
    const closeButton = root.querySelector('[data-ik-support-close]');
    const showContact = root.querySelector('[data-ik-support-show-contact]');
    const showHelp = root.querySelector('[data-ik-support-show-help]');
    const helpView = root.querySelector('[data-ik-support-view="help"]');
    const contactView = root.querySelector('[data-ik-support-view="contact"]');
    const focusTarget = root.querySelector('[data-ik-support-close]');
    const contactState = root.querySelector('[data-ik-contact-state]')?.dataset.ikContactState;

    const setView = view => {
      if (helpView) helpView.hidden = view !== 'help';
      if (contactView) contactView.hidden = view !== 'contact';
    };
    const open = view => {
      setView(view || 'help');
      root.classList.add('is-open');
      window.setTimeout(() => focusTarget?.focus(), 0);
    };
    const close = () => {
      root.classList.remove('is-open');
      openButton?.focus();
    };

    openButton?.addEventListener('click', () => open('help'));
    closeButton?.addEventListener('click', close);
    showContact?.addEventListener('click', () => setView('contact'));
    showHelp?.addEventListener('click', () => setView('help'));
    backdrop?.addEventListener('mousedown', event => {
      if (event.target === backdrop) close();
    });
    document.addEventListener('keydown', event => {
      if (event.key === 'Escape' && root.classList.contains('is-open')) close();
    });

    root.querySelectorAll('[data-ik-contact-form]').forEach(hydrateContactForm);
    if (contactState === 'success' || contactState === 'error') open('contact');
  }

  function mountAll(scope = document) {
    scope.querySelectorAll?.('[data-ik-contact-form]').forEach(hydrateContactForm);
    if (scope.matches?.('[data-ik-support]')) mountSupport(scope);
    scope.querySelectorAll?.('[data-ik-support]').forEach(mountSupport);
  }

  const initialise = () => {
    try { mountAll(); } catch (_error) {}
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialise, { once: true });
  else initialise();
  document.addEventListener('shopify:section:load', event => mountAll(event.target));
})();
